<template>
    <Modal :show="showModal" :modalTitle="titleText" :inHeader="miniChat" @close="closeModal" :modalClass="'chat-modal-report'">
      <template #body>
        <form @submit.prevent="submitForm" novalidate>
          <p class="chat-modal-report__note">{{ $t("Reports are reviewed by Wyrel support") }}</p>
          <div class="form-group report-type">
            <CustomSelect :options="reportTypes" v-model="selectedReportType" :selectId="'report_type'"
                    :selectedValue="selectedReportType" :labelSelect='$t("Report type")'/>
          </div>
          <InputGroup
            type="text"
            v-model="message"
            :placeholder="$t('Report description')"
            :maxLength="999"
            :is
            fieldType='textarea'
            required
            inputClass="message-input"
            :errorMessage="errorValidate"
        />
        <div class="chat-modal-report__actions">
          <button type="button" class="chat-modal-report__cancel" @click="closeModal">{{ $t("Cancel") }}</button>
          <Button
              type="submit"
              :buttonText="$t('Report')"
              :isFormChanged="isFormChanged"
              additionalClasses="report-btn"
              colorClass="red"
            />
        </div>
      </form>
      </template>
    </Modal>
</template>
  
  <script>
  import Modal from '/webpack-assets/vue/templates/chat/parts/ChatModal.vue';
  import Button from '/webpack-assets/vue/components/Button.vue';
  import CustomSelect from '/webpack-assets/vue/components/CustomSelect.vue';
  import InputGroup from '/webpack-assets/vue/components/InputGroup.vue';
  import { renderAlertVue } from "/webpack-assets/vue/utils/common.js";
  import { eventBus } from '/webpack-assets/vue/utils/eventBus.js';
  import axios from '/webpack-assets/vue/config/axios-config';

  export default {
    components: {
      Modal,
      Button,
      CustomSelect,
      InputGroup
    },
    data() {
      return {
        showModal: false,
        message: '',
        reportUserId: null,
        isFormChanged: false,
        titleText: this.$t('Customer report'),
        successMessage: this.$t('The report has been successfully submitted!'),
        errorMessage: this.$t('The report type has been already created!'),
        errorValidate: '',
        selectedReportType: 1,
        reportTypes: window.header?.chat?.report_types || [],
      };
    },
    props: {
      miniChat: {
        type: Boolean,
        default: false
      }
    },
    mounted() {
      eventBus.on('handle-open-modal-report', ({ isOpen, userId }) => {
          this.showModal = isOpen;
          this.reportUserId = userId;
      });
    },
    beforeUnmount() {
        eventBus.off('handle-open-modal-report');
    },
    watch: {
      message(val) {
        if (this.message.trim() !== '') {
          this.isFormChanged = true
          this.errorValidate = ''
        } else {
          this.isFormChanged = false
        }
      },
    },
    methods: {
        openModal() {
            if (this.isShowModalReport) {
                this.showModal = true;
            }
        },
        closeModal() {
            this.showModal = false;
            this.errorValidate = '';
            eventBus.emit('handle-close-modal-report');
        },
        async submitForm() {
          if (!this.message.trim()) {
            this.errorValidate = this.$t('{title} cannot be blank', {title: this.$t('Report description')} );
            return;
          }

          try {
            const response = await axios({
                    method: 'post',
                    url: '/chat-api/add-report',
                    data: { message: this.message, uuid: this.reportUserId, type: this.selectedReportType }
                });
            if (response.data.status === 'success') {
              renderAlertVue(this.successMessage, 'success', 2000)
            }
          } catch (error) {
            console.error('Request failed:', error);
            renderAlertVue(this.errorMessage, 'danger', 2000)
          } finally {
            this.closeModal()
            this.showModal = false
            this.message = '';
            this.selectedReportType = 1;
          }
      }
    },
  };
  </script>
  
  <style lang="scss">
  .chat-modal-report{
    max-width: 440px !important;
    .modal-body{
      padding: 16px 20px 20px !important;
      form{
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 16px;
        .report-type{
          margin-bottom: 0;
        }
        .textarea{
          .form-input-border{
            display: flex;
          }
          .help-block{
            text-align: left;
          }
        }
      }
    }
    &__note{
      text-align: left;
      margin: 0;
      padding: 12px;
      border-radius: 10px;
      background: var(--wc-bg);
      font-family: var(--wc-font);
      font-size: 13px;
      line-height: 18px;
      color: var(--wc-text-2);
    }
    &__actions{
      display: flex;
      justify-content: flex-end;
      gap: 8px;
      .button,
      .chat-modal-report__cancel{
        display: inline-flex;
        align-items: center;
        justify-content: center;
        line-height: 20px;
        width: auto;
        max-width: none;
        height: 40px;
        margin: 0;
        padding: 0 16px;
        border-radius: 8px;
        font-family: var(--wc-font-medium);
        font-size: 14px;
        text-transform: none;
      }
      .chat-modal-report__cancel{
        border: 1px solid var(--wc-border);
        background: var(--wc-surface);
        color: var(--wc-text);
        &:hover{
          background: var(--wc-bg);
        }
      }
      .report-btn{
        border: 0;
        background: #C42B2B !important;
        color: var(--wc-on-accent) !important;
      }
    }
  }
  </style>